	define([
	"dojo/_base/declare",
	"csi/widget/RadioToggleButton",
	"./_Plugin",
	"dojo/text!./resources/Button.html",
], function(declare,RadioToggleButton,_Plugin,template) {

	return declare([RadioToggleButton, _Plugin], {
		radioClass: "listButton",
		templateString: template,

		/**
		 * Enable lists if shape(s) are selected
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			if (shapes && shapes.length && textAttrs &&
				!this.editor.canvasApp.selection.isSelectedShapePlaceholder()) {
				this.set("checked", textAttrs[this.orderType] === this.orderType, false);
				return this.inherited(arguments);
			} else {
				return false;
			}
		},

		/**
		 * Apply style
		 * @param  {Event} e
		 */
		onClick: function(e) {
			this.editor.setTextStyle(this.orderType, null, this.checked);
		}
	});
});
